import { z } from 'zod'
import { personSchema } from './person'
import { addressSchema } from './address'
import { documentSchema } from './document'

/**
 * Schema completo para Viatger
 * Combina person + address + document + campos específicos
 */
export const viatgerSchema = personSchema
  .merge(addressSchema)
  .merge(documentSchema) // Documento obligatorio para viatgers (Mossos)
  .extend({
    // Campos específicos de Viatger
    reserva_id: z.string().min(1, 'La reserva és obligatòria'),
    peticions_especials: z.string().optional(),
    es_titular: z.boolean().default(false),
    consentiment_rgpd: z.boolean().default(false),
    consentiment_marketing: z.boolean().default(false),
  })

export type ViatgerFormData = z.infer<typeof viatgerSchema>
